import { Action, createReducer, on } from '@ngrx/store';
import { DetallesCartera } from 'src/app/models/detallesCartera.model';
import * as DetallesCarteraAction from '../actions/carteraDetalles.actions';


export interface DetallesCarteraState {
    list: any[],
    DetallesCartera?: DetallesCartera,
    DetallesCarteras?: DetallesCartera[]
}
const initialState: DetallesCarteraState = {
    list: [],
    DetallesCartera: {}
}

const _DetallesCarteraReducer = createReducer(
    initialState,
    on(DetallesCarteraAction.addDetallesCarteras, (state, { list }) => ({
        ...state,
        list: [...list]
    })),
    on(DetallesCarteraAction.listDetallesCarteras, (state) => ({
        ...state,
    })),
    on(DetallesCarteraAction.addDetallesCartera, (state, { Detallescartera }) => ({
        ...state,
        list: [...state.list, Detallescartera]
    })),
    on(DetallesCarteraAction.selectDetallesCartera, (state, { id }) => ({
        ...state,
        Detallescartera: state.list.find(el => el.car_id == id)
    })),
    on(DetallesCarteraAction.deleteDetallesCartera, (state, { id }) => ({
        ...state,
        list: state.list.filter(x => x.car_id != id)
    })),
    on(DetallesCarteraAction.updateListDetallesCarteras, (state, { id, DetallesCartera }) => ({
        ...state,
        list: state.list.map((el) => {
            
            if (el.car_id == id) {
                return el = {
                    ...DetallesCartera
                }

            } else {
                return el;
            }
        })
    }))
)


export function DetallesCarteraReducer(state: DetallesCarteraState, action: Action) {
    return _DetallesCarteraReducer(state, action);
}